<template>
  <header
    v-if="isMobile()"
    :class="{
      'bg-[#181818] shadow-md backdrop-blur-xs': isScolling,
      'bg-transparent': !isScolling,
    }"
    class="full h-20 top-0 py-5 px-4 flex items-center justify-between w-full z-50 transition-all duration-500 ease-in-out"
  >
    <RouterLink to="/landing" class="h-10">
      <img
        src="../../assets/logo-white.png"
        alt="mockey logo"
        height="40"
        width="85"
      />
    </RouterLink>
    <RouterLink v-if="!isSubscriber" to="/pricing">
      <img
        src="../../assets/icons/badge-combo.svg"
        alt="mockey logo"
        height="20"
        width="50"
      />
    </RouterLink>
  </header>
  <div v-else class="h-max border-b-[0.5px] sticky top-0 z-50 bg-white">
    <header
      class="w-full flex items-center justify-between px-4 py-2 bg-gradient"
    >
      <div>
        <NavMenu />
      </div>
      <div
        v-if="isUserLoaded && isSubscriberLoaded"
        class="flex items-center gap-x-1"
      >
        <RouterLink
          v-if="!isSubscriber"
          to="/pricing"
          class="px-2 py-2.5 rounded-lg cursor-pointer flex gap-x-2"
        >
          <span class="text-label-lg hidden lg:block text-[#344054]">
            Pricing
          </span>
          <div class="flex">
            <img
              class="h-5 w-5 block lg:hidden"
              :src="badgeIcon"
              alt="Premium Icon"
            />
            <img
              class="h-5 hidden lg:block"
              :src="badgeCombo"
              alt="badge combo Icon"
            />
          </div>
        </RouterLink>
        <template v-if="authUser">
          <CreditsButton />
          <AIGenerationPanel />
        </template>
        <UserAuthControl @logout-event="$emit('handleLogout')" />
      </div>
      <div v-else>
        <Skeleton
          class="w-10 sm:w-56 h-11 rounded-full sm:rounded-lg img-background"
        ></Skeleton>
      </div>
    </header>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount, ref, computed } from "vue";
import { useMockupStore } from "@/datastore/module/mockup.js";
import { isMobile } from "@/util/common.util";
import UserAuthControl from "@/components/navbar/UserAuthControl.vue";
import AIGenerationPanel from "@/components/navbar/AIGenerationPanel.vue";
import CreditsButton from "@/components/navbar/CreditsButton.vue";
import NavMenu from "@/components/navbar/NavMenu.vue";
import badgeCombo from "@/assets/icons/badge-combo.svg";
import badgeIcon from "@/assets/icons/badge.svg";
import { Skeleton } from "@/components/ui/skeleton";

const store = useMockupStore();

const isScolling = ref(false);

const authUser = computed(() => store?.authUser);
const isSubscriber = computed(() => store?.isSubscriber);
const isUserLoaded = computed(() => store?.isUserLoaded);
const isSubscriberLoaded = computed(() => store?.isSubscriberLoaded);

onMounted(() => {
  window.addEventListener("scroll", handleScroll);
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", handleScroll);
});

function handleScroll() {
  // isScolling.value = window.scrollY > 100;
}
</script>

<style scoped>
header {
  transition:
    background-color 0.3s ease-in-out,
    box-shadow 0.3s ease-in-out;
}

.bg-gradient {
  background: linear-gradient(
    180deg,
    rgba(227, 80, 142, 0.2) -20%,
    rgba(255, 255, 255, 0) 60%
  );
}
</style>
